import {customElement, property, state} from 'lit/decorators.js';
import {html, LitElement} from 'lit';
import {autoLogoutTextStyle} from "@/components/auto-logout-text/auto-logout-text.styles.ts";

@customElement('sbk-auto-logout-text')
export class SbkAutoLogout extends LitElement {
    @property()
    label = 'min until Logout';

    @state()
    remainingSeconds = 0;

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('sbk-update-logout-countdown', this._updateTime);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('sbk-update-logout-countdown', this._updateTime);
    }

    static get styles() {
        return autoLogoutTextStyle;
    }

    render() {
        return html`
            <p class="small">${this.setText()}&nbsp;${this.label}</p>
        `;
    }

    setText() {
        return html`<span class="time">${this.fmtSecToMin(this.remainingSeconds)}</span>`;
    }

    _updateTime = (event: Event) => {
        this.remainingSeconds = (<CustomEvent>event).detail?.remainingSeconds;
    }

    fmtSecToMin(s: number): string{
        const min = (s-(s%=60))/60;
        return String(min)
    }
}
